export const productRoutes = {
	productIndex: '/products',
	productEdit: (id?: string) => `/products/${id ?? ':id'}`,
	productHistory: (id?: string) => `/products/${id ?? ':id'}/history`,
	productAdd: '/products/add'
} as const
